import React from "react";
import classnames from "classnames";
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { bindActionCreators } from 'redux';
import { entityIdentRowActions } from '../../../store/entityIdentRowStore';
import { popupActions } from '../../../store/popupStore';
import { relationsSearchActions } from '../../../store/relationsSearchStore'
import { withRouter } from 'react-router';
import { hasPermission } from "../../../store/apiWrapper";
import { isOnAny, isOnMobile, getModeClasses } from '../modeClassesResolver';
import Map from '../../common/mapComponent';
import FoIcon from '../../../img/icons/FyzickaOsoba';
import FpoIcon from '../../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../../img/icons/PravnickaOsoba';
import AddrIcon from '../../../img/icons/Domu';
import HistoryIcon from '../../../img/icons/Historie';
import { strip } from "../../common/utils";
import { Link } from 'react-router-dom';
import { PngFlag } from "../../common/pngFlag";

class RelationSearchSearchRow extends React.Component {
    render() {
        const entityInfo = this.props.s;
        const mode = this.mergeModes(this.props.mode, { names: 'desktop|mobile', buttons: 'desktop|mobile', extraData: 'desktop|mobile', basicLink: 'desktop|mobile' });

        if (entityInfo) {
            return (
                <div key={entityInfo.entityId} className={classnames('qs-result bs-qs-result', { 'qs-result-historical': entityInfo.isCancelled })}>
                    {this.renderEntityLine(entityInfo, mode)}
                    {isOnAny(mode.extraData) && this.renderExtraLine(entityInfo, mode)}
                </div>
            );
        } else {
            return null;
        }
    }

    renderEntityLine = (entityInfo, mode) => {
        let batch = [];
        let extraData = [];
        if (mode.extraData) {
            if (entityInfo.type === 2 && entityInfo.dateOfBirth && entityInfo.dateOfBirth.trim()) {
                extraData.push(
                    <React.Fragment key="1">
                        <Translate id="Report.NaturalIdentData.DateOfBirth" />:&nbsp;
                        {entityInfo.dateOfBirthFormated}
                    </React.Fragment>
                );
            }

            if (entityInfo.type !== 2 && entityInfo.ico && entityInfo.ico.trim()) {
                extraData.push(
                    <React.Fragment key="2">
                        <Translate id="Report.CompanyIdentification.Ico" />:&nbsp;
                        {ReactHtmlParser(entityInfo.ico)}
                    </React.Fragment>
                );
            }
        }

        if (extraData.length > 0)
            extraData = [<React.Fragment key="0"> │&nbsp;</React.Fragment>, ...extraData];

        const Icon = entityInfo.type === 1 ? (entityInfo.entrepreneur === true ? FpoIcon : PoIcon) : entityInfo.reports.AR ? AddrIcon : FoIcon;

        return (
            <div style={{ display: "flex" }}>
                <Icon className={`search-result-icon ${entityInfo.isCancelled ? 'svg-history-fill' : 'svg-standard-fill'}`} />
                &nbsp;
                <div className={`qs-highlighted-match${this.props.wrapEntityName ? " wrap" : ""}`} title={this.props.queryName}
                    style={{ display: "flex", alignItems: "center", flexWrap: 'wrap' }}
                >
                    <div style={{ display: 'flex' }}>
                        {(isNullOrUndefined(this.props.quickReportLink) || this.props.quickReportLink === true) && hasPermission(null, "SimpleReport") ?
                            this.renderBasicInfoLinkToWindow(entityInfo) :
                            <React.Fragment>{ReactHtmlParser(`<b>${entityInfo.queryName}</b>`)}</React.Fragment>
                        }<PngFlag countryCode={entityInfo.country} />{extraData}
                    </div>
                    <div style={{ display: 'flex', marginLeft: 'auto' }}>{batch}</div>
                </div>
            </div>
        )
    }

    renderBasicInfoLinkToWindow = (entityInfo) => {
        if (isNullOrUndefined(entityInfo.entityId))
            return null;

        return (
            <Link
                className={classnames('bi-label', { 'is-normal': localStorage.locales_url_format === 'normal' })} onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
                to='#' title={strip(entityInfo.name)}
                onClick={() => { window.open(`/report/quick${entityInfo.reports.AR ? '-address' : ''}/${entityInfo.entityId}`, "_blank", "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10"); }}
            >
                {ReactHtmlParser(`<b>${entityInfo.name}</b>`)}
            </Link>
        );
    }

    renderExtraLine = (entityInfo, mode) => {
        return (
            <div className={classnames(Object.assign({ 'qs-result-2': true }, getModeClasses(mode.extraData)))}>
                {entityInfo.hasHistoricalNames && <div title={this.props.translate("Search.HistoryNames")}>
                    <HistoryIcon className="search-row-history-icon" style={{ height: '1.25em', width: '1.25em', verticalAlign: "sub" }} />
                    <span className="qs-historical-names" title={this.getHistoricalNamesString(entityInfo.historyMatch.names, true)}>
                        <span> </span>
                        {ReactHtmlParser(this.getHistoricalNamesString(entityInfo.historyMatch.names))}
                    </span>
                </div>}
                {entityInfo.address && <div className="qs-address">
                    <span title={entityInfo.address}>
                        {entityInfo.address}
                        <span onMouseUp={this.props.onMouseReleasedIgnoreEvents}>
                            <Map address={entityInfo.address} id={entityInfo.entityId} />
                        </span>
                    </span>
                </div>}
            </div>
        );
    }

    getHistoricalNamesString = (nameList, removeTags = false) => {
        if (isNullOrUndefined(nameList))
            return "";

        let result = nameList.join("; ");
        return removeTags ? result.replace(/<\/?\s*em>/g, "") : result;
    }

    mergeModes = function (input, def) {
        if (input === null || input === undefined) { return def; }
        const keys = Object.keys(def);
        for (let index = 0; index < keys.length; index++) {
            if (!input.hasOwnProperty(keys[index])) {
                input[keys[index]] = def[keys[index]];
            }
        }
        return input;
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }
}

export default withRouter(withLocalize(connect(
    state => state.entityIdentRow,
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...popupActions, ...relationsSearchActions }, dispatch),
)(RelationSearchSearchRow)));